// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3sDxK","inputWrap":"CustomTip_inputWrap__3BUcJ"};